import { FeatureFlagKey } from '@/features/feature-flags/presentation/types/feature-flag-key';
import { Configuration } from './types';

/**
 * The base configuration targets the production environment.
 *
 * This can be overridden by the environment-specific configurations.
 */
export const config: Partial<Configuration> = {
  portalApi: 'https://api.emergency.wa.gov.au',
  mapbox: {
    // TODO: Update this to the latest production styles once they are available.
    defaultStyle: 'mapbox://styles/robgenvis/cmizqxrq9006201r81qml3b97',
    // TODO: Update this to the latest production styles once they are available.
    satelliteStyle: 'mapbox://styles/robgenvis/cmizqz3k4006301sn591b269u',
    token: 'pk.eyJ1Ijoicm9iZ2VudmlzIiwiYSI6ImNtazNzbGFwazAwNzgzZ3IyaTZqa2ZtdmEifQ.jYdk0UtDg1hk7AOjz69dbQ', // "EWA Website - Test" token
    overlaysTileSet: 'mapbox://robgenvis.ewa-overlays-prd',
    overlayTileSetLayers: {
      dfesRegions: 'dfes-regions-tileset-layer-prd',
      lga: 'lga-tileset-layer-prd',
      lgaCentres: 'lga-centres-tileset-layer-prd',
      pastoralStations: 'pastoral-stations-tileset-layer-prd',
      fdrRegions: 'fdr-regions-cr69-tileset-layer-prd',
      fdrCenters: 'fdr-centres-cr69-tileset-layer-prd',
    },
  },
  remoteHazardAssets: {
    iconAssetsPathSvg: 'https://genvis.com/assets/icons/map/pins',
    iconAssetsPathPng: 'https://genvis.com/assets/icons/map/pins/40x40',
  },
  geospatialBucket: 'https://d3d5cp23hc6r4p.cloudfront.net',
  // TODO: Update these to the production URLs once they are available.
  // This is the Preflight instance of the EmergencyVic proxy server.
  windTileBaseUrl: 'https://d2qs3zxczgqy2f.cloudfront.net',
  // This is the Preflight instance of the BOM proxy server.
  externalTileBaseUrl: 'https://dcmf2mat0wkt1.cloudfront.net',
  webTemplateStyleSheetUrl: 'https://genvis.com/assets/styles/ewa-webtemplate.css',
  sentry: {
    dsn: 'https://2946dfe99e66df21f5f92a4655a0b647@o4507253793816576.ingest.de.sentry.io/4507255077339216',
  },
  featureFlags: {
    [FeatureFlagKey.EnableMyEmergencyPlan]: true,
  },
};
